import { CircularProgress } from "@mui/material";
import { FC } from "react";
import "./Spinner.scss";
type SpinnerProps = {
  className?: string;
  size?: number | string;
};
const Spinner: FC<SpinnerProps> = ({ className, size }: SpinnerProps) => {
  return (
    <div className={`spinner ${className || ""}`}>
      <CircularProgress size={size} />
    </div>
  );
};

export default Spinner;
